export default "__VITE_ASSET__802dbce3__"